import React from 'react';
import sizes from 'react-sizes';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { MultiCarousel } from 'components';
import SmallRightArrow from 'images/shared/misc/SmallRightArrow';
import styled from 'styled-components';
import { getSlug, sortByGridOrder } from 'utils';

const LocationsMultiCarousel = ({ children, cards, gridOrder, viewportWidth }) => {
  const _cards = gridOrder ? sortByGridOrder(cards, gridOrder) : cards;
  return (
    _cards && (
      <Wrapper>
        {children && (
          <div
            style={{
              backgroundColor: '#e6e6e6',
              borderRadius: '10px',
              margin: '79px auto 40px',
              maxWidth: '1252px',
              padding: '2.5rem 1.5rem 2rem',
              width: '87.75%'
            }}>
            {children}
          </div>
        )}
        <MultiCarousel
          wideCarousel={true}
          leftArrowOffset={
            viewportWidth >= 1258
              ? '-1.1%'
              : viewportWidth >= 972
              ? '-6.75%'
              : viewportWidth >= 690
              ? '-10%'
              : 'calc(50% - 47.5px)'
          }
          rightArrowOffset={
            viewportWidth >= 1258
              ? 'calc(-1.1% + 6px)'
              : viewportWidth >= 972
              ? 'calc(-6.75% + 9px)'
              : viewportWidth >= 690
              ? 'calc(-10% + 8px)'
              : 'calc(50% - 47.5px)'
          }
          responsiveRules={{
            largeDesktop: {
              breakpoint: { max: 10000, min: 1258 },
              items: 3
            },
            desktop: {
              breakpoint: { max: 1257, min: 972 },
              items: 3
            },
            tablet: {
              breakpoint: { max: 971, min: 690 },
              items: 2
            },
            mobile: {
              breakpoint: { max: 971, min: 0 },
              items: 3
            }
          }}>
          {_cards.map(({ node: location }) => {
            const { title, locality, featuredImg } = location.childMarkdownRemark.frontmatter;
            const image = getImage(featuredImg.src);
            return (
              <Link to={`/locations/${getSlug(title)}`} key={title}>
                <Card>
                  <Graphic image={image} alt={featuredImg.alt} />
                  <CardText>
                    <h3>{locality}</h3>
                    <ViewLocation>
                      View Location <SmallRightArrow />
                    </ViewLocation>
                  </CardText>
                </Card>
              </Link>
            );
          })}
        </MultiCarousel>
      </Wrapper>
    )
  );
};

const Wrapper = styled.div`
  position: relative;
  .react-multi-carousel-list {
    padding: 1rem 0;
  }
`;

const Card = styled.div`
  display: grid;
  grid-template-rows: 200px auto;
  gap: 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 3px 3px 7px rgba(189, 189, 189, 0.4);
  height: 100%;
  width: 100%;
  position: relative;
  margin-right: 1rem;
  h3 {
    font-family: adelle, serif;
    color: var(--dynamic-dark-grey);
    font-weight: 600;
    font-style: normal;
    font-size: 1.25rem;
    line-height: 1.2;
    margin: 0;
  }
`;

const CardText = styled.div`
  align-items: center;
  position: relative;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 1rem 1.5rem;
  height: 100%;
`;

const Graphic = styled(GatsbyImage)`
  width: 100%;
  border-radius: 10px 10px 0 0;
`;

const ViewLocation = styled.p`
  font-family: 'proxima-nova', sans-serif;
  color: #bdbdbd;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: right;
  width: 100%;
`;

export default sizes(({ width }) => ({ viewportWidth: width && width }))(LocationsMultiCarousel);
